import React, { useEffect, useState } from "react";
import { Input, Button, Popconfirm, message, Tag, Tabs } from "antd";

import { Typography } from "antd";
import { Helmet } from "react-helmet";
import axios from "axios";
import { CheckOutlined } from "@ant-design/icons";
import RoleForm from "../components/Roles/RoleForm";
import RolePopup from "../components/Roles/RolePopup";
import RequirePermission from "../components/Common/RequirePermission";
const { Title } = Typography;

const Roles = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [roles, setRoles] = useState([]);
  const [editingRole, setEditingRole] = useState(null);

  const [createPermission, setCreatePermission] = useState(false);
  const [editPermission, setEditPermission] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [filterText, setFilterText] = useState("");

  const handleSearch = (e) => {
    const value = e.target.value;
    setFilterText(value);
    setCurrentPage(1);
  };

  const handleDefault = async (id) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/roles/default`,
        { id }
      );
      const updated_row_count = response.data.data.updated_row_count;
      if (updated_row_count !== 0) {
        message.success("Role set as default");
        await fetchData();
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
    const storedUser = JSON.parse(localStorage.getItem("userData"));
    const permissions = storedUser.permissions;
    setCreatePermission(parseInt(permissions["roles.create"]) === 1);
    setEditPermission(parseInt(permissions["roles.edit"]) === 1);
  }, []);

  useEffect(() => {
    const fetchTimer = setTimeout(() => {
      fetchData();
    }, 500);

    return () => clearTimeout(fetchTimer);
  }, [currentPage, filterText]);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + `/api/roles`,
        {
          params: {
            filter: filterText, // add filter if needed
            limit: 100,
            page: currentPage,
          },
        }
      );
      let roleData = response.data.data.data;
      setRoles(roleData);
    } catch (error) {
      console.error("Error fetching roles data", error);
    }
  };

  return (
    <RequirePermission permission="roles.view">
      <div style={{ padding: "1rem" }}>
        <Helmet>
          <title>{`${process.env.REACT_APP_NAME} | Roles`}</title>
        </Helmet>
        <Title level={3} style={{ marginBottom: "1rem" }}>
          Roles
        </Title>
        <div className="d-flex justify-content-between mb-3">
          <Input.Search
            placeholder="Search roles"
            value={filterText}
            onChange={handleSearch}
            style={{ width: 200 }}
          />
          {createPermission && (
            <Button
              type="primary"
              onClick={() => {
                setEditingRole(null);
                setIsModalOpen(true);
              }}
            >
              Add New Role
            </Button>
          )}
        </div>
        <Tabs
          defaultActiveKey={roles[0] && roles[0].id}
          tabPosition="left"
          className="bg-white p-3"
          items={roles.map((role) => {
            return {
              label: (
                <>
                  {role.name}
                  {role.is_default === 1 && (
                    <>
                      <br />
                      <Tag>Default</Tag>
                    </>
                  )}
                  {role.is_default === 0 && editPermission && (
                    <Popconfirm
                      title="Are you sure to make this role as default?"
                      onConfirm={() => handleDefault(role.id)}
                      okText="Yes"
                      cancelText="No"
                    >
                      &nbsp;
                      <Button size="small" icon={<CheckOutlined />} />
                    </Popconfirm>
                  )}
                </>
              ),
              key: role.id,
              children: (
                <RoleForm
                  editingRole={role}
                  handleUpdateList={() => fetchData()}
                />
              ),
            };
          })}
        />
        {isModalOpen && (
          <RolePopup
            isModalOpen={isModalOpen}
            closeModal={() => setIsModalOpen(false)}
            editingRole={editingRole}
            handleUpdateList={() => fetchData()}
          />
        )}
      </div>
    </RequirePermission>
  );
};

export default Roles;
